export default "__VITE_ASSET__Cdozrzp6__"